import { CalendarTypeModel } from './calendartype.model';

export class DateTypeModel {
    public dateTypeCode:string;
    public dateTypeName:string;
    public calendarType: CalendarTypeModel[];
}